/**
 * Section anchors, in the same order as the `nav` copy.
 *
 * Kept apart from `landing.ts` on purpose (T-PERF-01): that module imports
 * all three message catalogues, and the header, a client component, needs
 * only these three strings. Importing them from there put every namespace
 * of every language into the landing page's JavaScript.
 */
export const NAV_HREFS = ['#universities', '#how-it-works', '#faq']
